(function (){
    'use strict';

    angular
        .module('app')
        .directive('focusMe', function($timeout) {
          return {
            link: function(scope, element, attrs) {
              scope.$watch(attrs.focusMe, function(value) {
                if(value === true) { 
                    if (element.hasClass('ui-select-container')) {
                        if (element[0].children.length === 4) {
                            $timeout(function () {
                                element[0].children[3].focus();
                            }, 0);
                        }
                    } else {
                        element[0].focus();
                    }
                }
              });
            }
          };
        });
})();